import React from 'react'

import { Portlet } from '_zari/core'

import MainForm from './mainForm'

const NuevoAsientoContable = ({ idTituloViatico, mostrarListaSection, editarData, idSocio }) => {
  return (
    <Portlet>
      <Portlet.Header title='Nuevo con documento' hideClose />
      <Portlet.Body>
        <MainForm
          idTituloViatico={idTituloViatico}
          idSocio={idSocio}
          edicionInfo={editarData}
          mostrarListaSection={mostrarListaSection}
        />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoAsientoContable)
